import {ON_GEOLOCATE, ON_GEOLOCATE_ERROR} from '../locationLookup.js'
import {initAreaAutocomplete} from './components/areaAutocomplete.js'
import {fetchResults} from './utils/fetchResults.js'
import {scrollToContainer} from './utils/scrollToContainer.js'

const describeGeolocationError = (error) => {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            return 'Location access was denied, so we couldn\'t fill this in automatically - enter your location instead.'
        case error.POSITION_UNAVAILABLE:
            return 'Your location is currently unavailable - enter your location instead.'
        case error.TIMEOUT:
            return 'Finding your location took too long - enter your location instead.'
        default:
            return 'We couldn\'t find your location - enter your location instead.'
    }
}

// DevelopmentListPage/LocationListPage's own hero forms only (see
// PageHeroExtension's UseAjaxSearch/Hero.ss/SearchBar.ss) - hooks into the
// same AJAX filter flow pill filters/sort/pagination already use, rather than
// doing a full page reload, and scrolls to the results the same way
// pagination does.
const initAjaxSubmit = (searchForm) => {
    if (searchForm.dataset.ajax !== 'true') return

    const container = document.querySelector('.js-fetch-container')
    if (!container) return

    searchForm.addEventListener('submit', async (e) => {
        e.preventDefault()

        const url = new URL(searchForm.action, window.location.href)
        url.search = new URLSearchParams(new FormData(searchForm)).toString()
        url.hash = container.id
        const href = url.toString()

        const currentUrl = window.location.href
        window.history.pushState({}, '', href)

        scrollToContainer(container)

        const didFetchResults = await fetchResults({ container, fetchURL: href })

        if (!didFetchResults) {
            window.history.replaceState({}, '', currentUrl)
        }
    })
}

export const initSearchForm = async () => {

    const searchForm = document.querySelector('form.js-search-form')
    if (searchForm) {
        initAjaxSubmit(searchForm)

        // :focus-visible on a text input matches on mouse click as well as keyboard
        // in some browsers (Firefox notably) - track mousedown ourselves so the ring
        // only shows for keyboard focus, same as every other focusable element.
        const searchBarInput = searchForm.querySelector('#search-bar-input')
        if (searchBarInput) {
            searchBarInput.addEventListener('mousedown', () => {
                searchBarInput.classList.add('js-mouse-focused')
            })
            searchBarInput.addEventListener('blur', () => {
                searchBarInput.classList.remove('js-mouse-focused')
            })
        }

        const statusEl = searchForm.querySelector('.js-place-autocomplete-status')
        if (statusEl) {
            document.addEventListener(ON_GEOLOCATE_ERROR, (evt) => {
                statusEl.textContent = describeGeolocationError(evt.detail)
            })
        }

        initAreaAutocomplete(searchForm)

        const { Geocoder } = await google.maps.importLibrary('geocoding');
        const searchInput = searchForm.querySelector('input[name="q"]');
        const latitudeField = searchForm.querySelector('input[name="latitude"]')
        const longitudeField = searchForm.querySelector('input[name="longitude"]')
        const sortField = searchForm.querySelector('input[name="sort"]')
        if (searchInput && latitudeField && longitudeField) {
            document.addEventListener(ON_GEOLOCATE, async evt => {
                const {latitude, longitude} = evt.detail.coords;
                const latLng = {
                    lat: latitude,
                    lng: longitude,
                };
                const { results } = await new Geocoder().geocode({ location: latLng });
                if (results && results.length > 0) {
                    const address = results.find((result) => result.types.includes('postal_code_prefix'));
                    if (address) {
                        searchInput.value = address.formatted_address;
                    }
                }
                latitudeField.value = latitude
                latitudeField.disabled = false
                longitudeField.value = longitude
                longitudeField.disabled = false
                if (sortField) {
                    sortField.disabled = false
                }
            })
        }
    }

}
